import { render } from "./protocol_files.vue?vue&type=template&id=6e8cee87"
import script from "./protocol_files.vue?vue&type=script&lang=js"
export * from "./protocol_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e8cee87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e8cee87', __exports__)) {
    console.log('reload')
    api.reload('6e8cee87', __exports__)
  }
  
  module.hot.accept("./protocol_files.vue?vue&type=template&id=6e8cee87", () => {
    console.log('re-render')
    api.rerender('6e8cee87', render)
  })

}


export default __exports__